import React from 'react';
import Sidebar from '../components/Sidebar';
import MainContent from '../components/MainContent';
import './Home.css';

function Home({ onLogout }) {
  return (
    <div className="home-container">
      <Sidebar onLogout={onLogout} />
      <div className="main-section">
        <MainContent onLogout={onLogout} />
      </div>
    </div>
  );
}

export default Home;
